
export const emptyUITexts = {
    cart: {
        title: 'Your cart is empty',
        description: 'Get started renting with the most connected fleet in the industry',
        buttonLabel: 'Browse equipment'
    },
    checkout: {
        title: 'Your cart is empty',
        description: 'Get started renting with the most connected fleet in the industry',
        buttonLabel: 'Browse equipment'
    },
    orderDetails: {
        title: 'We were unable to find your order details.',
        description: 'Get started renting with the most connected fleet in the industry',
        buttonLabel: 'Browse equipment'
    },
    utilization: {
        title: 'No Rentals Found',
        description: 'You haven\'t rented any equipment yet! Click below to get started renting with us.',
        buttonLabel: 'BROWSE EQUIPMENT'
    }
} 